import { Recurso, UseCaseRecursoAsync } from "lib.common/dist/CleanArch";
import { AbonoPasarela } from "../entities/AbonoPasarela";
import { GetSomeConciliacionParams } from "../../utils/params/GetSomeConciliacionParams";
import { ConciliacionRepository } from "../repositories/ConciliacionRepository";
import { ErrDevGenerico } from "lib.common/dist/errorHandler";

export class GetSomeConciliacionUseCase<
    T_OUT extends AbonoPasarela
> extends UseCaseRecursoAsync<
    GetSomeConciliacionParams,
    T_OUT[]
> {
    private repository: ConciliacionRepository<T_OUT>;
    constructor(repository: ConciliacionRepository<T_OUT>) {
        super();
        this.repository = repository;
    }
    async call(input: GetSomeConciliacionParams): Promise<Recurso<T_OUT[]>> {
        try {
            return this.repository.getSomeConciliacion(input);
        } catch (error) {
            const errorCapa = new ErrDevGenerico(error as Error);
            return Recurso.fromError<T_OUT[]>(errorCapa);
        }
    }
}